"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = EquipmentList;
var _react = _interopRequireWildcard(require("react"));
var _commonOptionCard = require("@mmc/common-option-card");
var _commonI18n = require("@mmc/common-i18n");
var _clsx = _interopRequireDefault(require("clsx"));
var _equipmentList = _interopRequireDefault(require("./equipment-list.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function EquipmentList(_ref) {
  var _ref$equipmentList = _ref.equipmentList,
    equipmentList = _ref$equipmentList === void 0 ? [] : _ref$equipmentList,
    theme = _ref.theme,
    _ref$onEquipmentOptio = _ref.onEquipmentOptionSelected,
    onEquipmentOptionSelected = _ref$onEquipmentOptio === void 0 ? function () {
      return null;
    } : _ref$onEquipmentOptio,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    selectedModelCodeDefault = _ref.selectedModelCode;
  var _useState = (0, _react.useState)(selectedModelCodeDefault),
    selectedModelCode = _useState[0],
    setSelectedModelCode = _useState[1];
  var updateSelectedOption = function updateSelectedOption(_selectedModelCode) {
    setSelectedModelCode(_selectedModelCode);
    onEquipmentOptionSelected(_selectedModelCode);
  };
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: _equipmentList["default"].wrapper
  }, equipmentList.map(function (equipment) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: equipment.code + Math.random(),
      className: (0, _clsx["default"])(_equipmentList["default"].equipment)
    }, /*#__PURE__*/_react["default"].createElement(_commonOptionCard.CommonOptionCard, {
      theme: theme,
      onChange: function onChange() {
        return updateSelectedOption(equipment.code);
      },
      name: "additional-equipment-selector",
      id: equipment.id,
      value: equipment.code,
      label: equipment.title,
      fullTap: true,
      isSelected: selectedModelCode === equipment.code,
      type: "radio"
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      options: {
        value: equipment.price.value,
        displayValue: 'MSRP ###,###.##',
        currency: 'USD',
        locale: 'en-US'
      },
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      returnZero: true
    }), /*#__PURE__*/_react["default"].createElement("ul", {
      className: (0, _clsx["default"])(_equipmentList["default"].features)
    }, !!equipment.features.length && equipment.features.map(function (feature) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: feature.title + Math.random(),
        className: (0, _clsx["default"])(_equipmentList["default"].featureWrapper)
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _clsx["default"])(_equipmentList["default"].featureTitle, theme.headingSix)
      }, feature.title), !!feature.items.length && /*#__PURE__*/_react["default"].createElement("ul", null, feature.items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: item + Math.random(),
          className: (0, _clsx["default"])(_equipmentList["default"].featureItem, theme.smallType)
        }, item);
      })));
    }))));
  }));
}